import React, { Component } from "react";
import { numberWithCommas } from "../../../../helpers/dataHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Table, Navbar, Nav, Button } from "react-bootstrap";
import { openModal } from "../../../../store/actions/ModalActions";
import AverageViewFilter from "../../view_filters/Sales/AverageViewFilter";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { moduleNames } from "../../../../helpers/dashboardModuleNames";
import { DashboardContext } from "../../dashboard_context";

const customTextStyle = { textAlign: "center" };

class AveragePawn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }
  renderDifference = (diff) => {
    let isNegative = diff < 0;
    let appendPositive = isNegative ? "" : "+";
    let classStyle = isNegative ? "text-danger" : "text-success";
    let arrowSet = isNegative ? (
      <FontAwesomeIcon icon={faArrowDown} />
    ) : (
      <FontAwesomeIcon icon={faArrowUp} />
    );

    return (
      <p className={classStyle}>
        {`${appendPositive}${diff}% `}
        <span>{arrowSet}</span>
      </p>
    );
  };

  renderTableRows = (data, idx) => {
    let hasCollapsed = true;
    return (
      <React.Fragment key={idx}>
        <tr>
          <td colSpan="2">
            <hr />
          </td>
        </tr>
        <div
          key={idx}
          style={{ color: "#F4511E" }}
          className="mt-2"
          onDoubleClick={() => {
            hasCollapsed = !hasCollapsed;
          }}
        >
          {moment(new Date(data.key.currentYear, data.key.currentMonth))
            .subtract(1, "months")
            .format("MMMM YYYY")}
        </div>

        <tr key={idx}>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle}>
                {numberWithCommas(data.value.pieceDetails.currentAverage)}
              </h4>
              <div style={customTextStyle}>
                {this.renderDifference(
                  data.value.pieceDetails.percentageDifference
                )}
              </div>
            </React.Fragment>
          </td>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle} className="text-monospace">
                {`₱${numberWithCommas(
                  Math.round(data.value.amountDetails.currentAverage / 50) * 50
                )}`}
              </h4>
              <div>
                {this.renderDifference(
                  data.value.amountDetails.percentageDifference
                )}
              </div>
            </React.Fragment>
          </td>
        </tr>

        <div style={{ color: "#F4511E" }}>
          {moment(new Date(data.key.previousYear, data.key.previousMonth))
            .subtract(1, "months")
            .format("MMMM YYYY")}
        </div>

        <tr className="text-center">
          <td>
            <h4>{numberWithCommas(data.value.pieceDetails.previousAverage)}</h4>
          </td>
          <td>
            <h4 className="text-monospace">{`₱${numberWithCommas(
              Math.round(data.value.amountDetails.previousAverage / 50) * 50
            )}`}</h4>
          </td>
        </tr>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <Navbar>
          <Navbar.Brand
            className="h5"
            style={{ color: this.context.titleColor }}
          >
            {this.props.listTitle}
          </Navbar.Brand>
          <Navbar.Text>
            <p className="small">{this.props.subTitle}</p>
          </Navbar.Text>
          <Navbar.Collapse className="align-content-between">
            <Nav className="mr-auto" />
            <Nav>
              <Button
                className="m-1"
                size="sm"
                variant="outline-secondary"
                onClick={() => {
                  openModal({
                    title: "View Average Pawns",
                    size: "lg",
                    custom: false,
                    currentComponent: <AverageViewFilter />,
                  });
                }}
              >
                Filter
              </Button>
              <ModuleLocked
                Lock={() => this.context.Lock(moduleNames.salesAverage)}
                Unlock={() => this.context.Unlock(moduleNames.salesAverage)}
                isLocked={this.context.salesAverageLocked}
              />
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Table title="Average" borderless size="sm">
          <tbody>
            {this.props.list.map((data, idx) => {
              return this.renderTableRows(data, idx);
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
AveragePawn.contextType = DashboardContext;
export default AveragePawn;
